import React, { useEffect, useState, useRef } from 'react'
import { Table } from 'antd'
import { useSelector } from 'react-redux'
import { formatMessageNew } from '@/utils/common'
import AntdTableOptPage from '@/components/table/AntdTableOpt'
import ActionBar from '@/components/table/ActionBar'
let newCol = []
let totalW = 0
const AntdTablePage = props => {
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  // columnsKey，独一无二的表示，不能重复
  // columns {width}需要设置成数字，建议最小100(设置columnsKey时)
  const { columns, dataSource, pagination, columnsKey, scroll, iconTop, onDownload, optStyle, ...resProps } = props
  const [tableColumns, setTableColumns] = useState(columns || [])
  const [scrollX, setScrollX] = useState(100)
  let childrenFlag = useRef(false)
  useEffect(() => {
    initFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns])
  const initFun = () => {
    if (!columnsKey) {
      // 设置table列
      setTableColumns(columns)
      return
    }

    let localColumns = columnsKey && localStorage.getItem(columnsKey)
    if (localColumns) {
      try {
        let localColumnsJson = JSON.parse(localColumns)
        // 设置table列
        initTableColumns(localColumnsJson)
      } catch (error) {
        // 设置table列
        initTableColumns([], 'init')
      }
    } else {
      // 设置table列
      initTableColumns([], 'init')
    }
  }
  // 设置table列
  const initTableColumns = (ls, type) => {
    newCol = []
    totalW = 0
    let columnsClone = columns
    for (let index = 0; index < columnsClone.length; index++) {
      const element = { ...columnsClone[index] }
      if (!element.dataIndex) {
        newCol.push(element)
      } else {
        if (type === 'init') {
          initTableColumnsCommon(element, ls, type)
          newCol.push(element)
        } else {
          if (ls.includes(element.dataIndex)) {
            initTableColumnsCommon(element, ls, type)
            newCol.push(element)
          }
        }
      }
    }
    if (totalW > 1000) {
      setScrollX(totalW / 10)
    } else {
      setScrollX(100)
    }
    if (!type) {
      // 存储table列
      columnsKey && localStorage.setItem(columnsKey, JSON.stringify(ls))
    }
    // 设置table列
    setTableColumns(newCol)
  }
  const initTableColumnsCommon = (element, ls, type) => {
    let w = (element.width || 100) * 1
    if (typeof w === 'number' && w) {
      totalW += element.width || 100
    }
    if (element.children) {
      childrenFlag.current = true
      let children = element.children
      element.children = []
      initTableColumnsChildren(element, children, ls, type)
    }
  }
  const initTableColumnsChildren = (elementP, children, ls, type) => {
    for (let index = 0; index < children.length; index++) {
      const element = children[index]
      if (type === 'init') {
        initTableColumnsCommon(element, ls, type)
        elementP.children.push(element)
      } else {
        if (ls.includes(element.dataIndex)) {
          initTableColumnsCommon(element, ls, type)
          elementP.children.push(element)
        }
      }
    }
  }
  let scrollObj = {}
  // let scrollYDiff = 0
  // if (childrenFlag.current) {
  //   scrollYDiff += 40
  // }
  // if (pagination) {
  //   scrollYDiff += 55
  // }
  scrollObj = {
    // y: `calc(100vh - 150px - ${scrollYDiff * deviceSize}px)`
  }
  return (
    <div className="table_position_relative">
      {(columnsKey || onDownload) && (
        <div
          className="table_right_opt displayFlex alignC"
          style={{ top: -(iconTop ? iconTop * deviceSize : deviceSize * 20) * 1.5, ...optStyle }}
        >
          {onDownload && (
            <ActionBar onDownload={onDownload} style={{ paddingTop: 2, paddingBottom: 0, paddingRight: 0 }} />
          )}
          {columnsKey && (
            <div style={{ marginLeft: deviceSize * 10 }}>
              <AntdTableOptPage
                columnsChange={newColumns => {
                  initTableColumns(newColumns)
                }}
                tableColumns={tableColumns}
                columns={columns.filter(itemMap => itemMap.dataIndex)}
                iconTop={iconTop}
              />
            </div>
          )}
        </div>
      )}
      <Table
        size="small"
        dataSource={dataSource.map((data, index) => {
          return { ...data, key: index }
        })}
        bordered
        columns={tableColumns}
        scroll={scroll ? { ...scrollObj, ...scroll } : columnsKey ? { ...scrollObj, x: `${scrollX}%` } : scrollObj}
        pagination={
          pagination
            ? {
                current: pagination.currentPage,
                pageSize: pagination.pageSize,
                total: pagination.total,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: [10, 20, 50, 100, 200],
                rootClassName: 'paginationClass paginationClassSticky',
                showTotal: total => `${formatMessageNew('languageObj.commonLocale.total')} ${total}`
              }
            : false
        }
        sticky={{ offsetHeader: 0, offsetScroll: pagination ? 50 * deviceSize : 10 }}
        {...resProps}
      />
    </div>
  )
}
export default AntdTablePage
